import { render, staticRenderFns } from "./EquipmentSlot.vue?vue&type=template&id=23425134&scoped=true&"
import script from "./EquipmentSlot.vue?vue&type=script&lang=js&"
export * from "./EquipmentSlot.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentSlot.vue?vue&type=style&index=0&id=23425134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23425134",
  null
  
)

export default component.exports